export enum CustomEndpointCreateOrEditFieldName {
  Name = 'name',
  Method = 'method',
  Path = 'path',
  Code = 'code',
  isMocked = 'isMocked',
  MockResponse = 'mockResponse',
  DataModel = 'dataModel'
}
